import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { ProtectedRoutes } from './Routes/ProtectedRoutes';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import AddMember from './Pages/Member/AddMember';
import Claims from './Pages/Claims';
import Documents from './Pages/Documents';
import Notifications from './Pages/Notifications';
import HelpDesk from './Pages/HelpDesk';
import Reports from './Pages/Reports';
import Settings from './Pages/Settings';
import MainLayout from './Components/Layouts/MainLayout';
import Loader from './Pages/Loader';
import DocumentView from './Pages/DocumentView';
import { ConfirmProvider } from 'material-ui-confirm';
import { ThemeProvider } from '@emotion/react';
import { lightTheme } from './Theme/theme';
import "react-toastify/dist/ReactToastify.css";
import DocumentsViewStatus from './Pages/DocumentStatusWise';
import TransactionHistory from './Pages/TransactionHistory';
import MemberSearch from './Pages/MemberSearch';
import AllTransaction from './Pages/AllTransaction';
import ViewMember from './Pages/ViewMember';
import PaymentRequest from './Pages/PaymentRequest';
import OrganisationMembers from './Pages/OrganisationMembers';
import OrganisationPayment from './Pages/OrganisationPayment';
import OrganisationManagement from './Pages/OrganisationManagement';
import Website from './Pages/Website';
import Template from './Pages/Template';
import Communication from './Pages/Communication';
import Reminders from './Pages/Reminders';
import PublicPayment from './Pages/PublicPayment';

// Expense Module imports
import { ExpensesList, ExpenseForm, ExpensesDashboard, ExpenseCategories, ExpenseReports } from './Pages/Expenses';

// Post Generator Module imports
import { PostCategories, PostTemplates, TemplateEditor } from './Pages/PostGenerator';

// Landing Page imports
import LandingLayout from './Components/Landing/LandingLayout';
import LandingHome from './Pages/Landing/LandingHome';
import Events from './Pages/Landing/Events';
import EventDetails from './Pages/Landing/EventDetails';
import AboutUs from './Pages/Landing/AboutUs';
import ContactUs from './Pages/Landing/ContactUs';
import PressAndMedia from './Pages/Landing/PressAndMedia';
import PrivacyPolicy from './Pages/Landing/PrivacyPolicy';
import TermsandConditions from './Pages/Landing/TermsandConditions';
import PostGenerator from './Pages/Landing/PostGenerator';
import MemberPostGenerator from './Pages/Landing/MemberPostGenerator';

function App() {
  return (
    <BrowserRouter>
      <Loader />
      <ToastContainer />
      <ThemeProvider theme={lightTheme}>
        <ConfirmProvider
          defaultOptions={{
            confirmationButtonProps: {
              variant: "contained",
            },
            cancellationButtonProps: {
              variant: "outlined",
            },
          }}
        >
          <Routes>
            {/* Landing Page Routes */}
            <Route path="/" element={<LandingLayout><LandingHome /></LandingLayout>} />
            <Route path="/events" element={<LandingLayout><Events /></LandingLayout>} />
            <Route path="/event/:id" element={<LandingLayout><EventDetails /></LandingLayout>} />
            <Route path="/about-us" element={<LandingLayout><AboutUs /></LandingLayout>} />
            <Route path="/contact-us" element={<LandingLayout><ContactUs /></LandingLayout>} />
            <Route path="/press-and-media" element={<LandingLayout><PressAndMedia /></LandingLayout>} />
            <Route path="/privacy-policy" element={<LandingLayout><PrivacyPolicy /></LandingLayout>} />
            <Route path="/terms-and-conditions" element={<LandingLayout><TermsandConditions /></LandingLayout>} />
            <Route path="/post-generator" element={<LandingLayout><PostGenerator /></LandingLayout>} />
            <Route path="/member/post-generator" element={<LandingLayout><MemberPostGenerator /></LandingLayout>} />

            {/* Public Payment Route (WhatsApp Renewal Links) */}
            <Route path="/pay/:shortCode" element={<PublicPayment />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<MainLayout><Login /></MainLayout>} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/admin" element={<MainLayout><Dashboard /></MainLayout>} />
              <Route path="/admin/addMember" element={<MainLayout><AddMember /></MainLayout>} />
              <Route path="/admin/claims" element={<MainLayout><Claims /></MainLayout>} />
              <Route path="/admin/documents" element={<MainLayout><Documents /></MainLayout>} />
              <Route path="/admin/documents-view-status" element={<MainLayout><DocumentsViewStatus /></MainLayout>} />
              <Route path="/admin/documents-view" element={<MainLayout><DocumentView /></MainLayout>} />
              <Route path="/admin/notifications" element={<MainLayout><Notifications /></MainLayout>} />
              <Route path="/admin/helpDesk" element={<MainLayout><HelpDesk /></MainLayout>} />
              <Route path="/admin/reports" element={<MainLayout><Reports /></MainLayout>} />
              <Route path="/admin/transactionHistory" element={<MainLayout><TransactionHistory /></MainLayout>} />
              <Route path="/admin/settings" element={<MainLayout><Settings /></MainLayout>} />
              <Route path="/admin/memberSearch" element={<MainLayout><MemberSearch /></MainLayout>} />
              <Route path="/admin/allTransactions" element={<MainLayout><AllTransaction /></MainLayout>} />
              <Route path="/admin/view-member" element={<MainLayout><ViewMember /></MainLayout>} />
              <Route path="/admin/payment-request" element={<MainLayout><PaymentRequest /></MainLayout>} />
              <Route path="/admin/organisation-members" element={<MainLayout><OrganisationMembers /></MainLayout>} />
              <Route path="/admin/organisation-payment" element={<MainLayout><OrganisationPayment /></MainLayout>} />
              <Route path="/admin/organisation-management" element={<MainLayout><OrganisationManagement /></MainLayout>} />
              <Route path="/admin/website" element={<MainLayout><Website /></MainLayout>} />
              <Route path="/admin/template" element={<MainLayout><Template /></MainLayout>} />
              <Route path="/admin/communication" element={<MainLayout><Communication /></MainLayout>} />
              <Route path="/admin/reminders" element={<MainLayout><Reminders /></MainLayout>} />
              
              {/* Expense Module Routes */}
              <Route path="/admin/expenses" element={<MainLayout><ExpensesList /></MainLayout>} />
              <Route path="/admin/expenses/dashboard" element={<MainLayout><ExpensesDashboard /></MainLayout>} />
              <Route path="/admin/expenses/add" element={<MainLayout><ExpenseForm /></MainLayout>} />
              <Route path="/admin/expenses/edit/:id" element={<MainLayout><ExpenseForm /></MainLayout>} />
              <Route path="/admin/expenses/view/:id" element={<MainLayout><ExpenseForm /></MainLayout>} />
              <Route path="/admin/expenses/categories" element={<MainLayout><ExpenseCategories /></MainLayout>} />
              <Route path="/admin/expenses/reports" element={<MainLayout><ExpenseReports /></MainLayout>} />

              {/* Post Generator Module Routes */}
              <Route path="/admin/post-generator/categories" element={<MainLayout><PostCategories /></MainLayout>} />
              <Route path="/admin/post-generator/templates" element={<MainLayout><PostTemplates /></MainLayout>} />
              <Route path="/admin/post-generator/template/add" element={<MainLayout><TemplateEditor /></MainLayout>} />
              <Route path="/admin/post-generator/template/edit/:id" element={<MainLayout><TemplateEditor /></MainLayout>} />
            </Route>
          </Routes>
        </ConfirmProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;

